export const TEAM_ROLES = ['viewer', 'producer', 'owner'] as const
export type TeamRole = (typeof TEAM_ROLES)[number]

/** Producers control the session (record, pause, mute, remove, promote); guests take part. */
export const SESSION_ROLES = ['producer', 'guest'] as const
export type SessionRole = (typeof SESSION_ROLES)[number]

const rank: Record<TeamRole, number> = { viewer: 0, producer: 1, owner: 2 }

export function hasTeamRole(actual: TeamRole, required: TeamRole): boolean {
  return rank[actual] >= rank[required]
}

/** The role a team member gets when entering one of the team's studios. */
export function sessionRoleForTeamRole(role: TeamRole): SessionRole {
  return hasTeamRole(role, 'producer') ? 'producer' : 'guest'
}

export const TEAM_ROLE_LABEL: Record<TeamRole, string> = {
  owner: 'Owner',
  producer: 'Producer',
  viewer: 'Viewer',
}
